import { atom } from 'jotai';

export const deviceKindAtom = atom<string | undefined>(undefined);
deviceKindAtom.debugLabel = 'BulkEditParamsState.deviceKindAtom';

export const deviceIdsAtom = atom<string[] | undefined>(undefined);
deviceIdsAtom.debugLabel = 'BulkEditParamsState.deviceIdsAtom';

export type PushOutMode = 'edit' | 'preview';

export const pushOutModeAtom = atom<PushOutMode | null>(null);
pushOutModeAtom.debugLabel = 'BulkEditParamsState.pushOutModeAtom';

/** Derived read-only atom — true when any push out mode is active. */
export const pushOutOpenAtom = atom((get) => get(pushOutModeAtom) !== null);
pushOutOpenAtom.debugLabel = 'BulkEditParamsState.pushOutOpenAtom';
